module.exports = __webpack_public_path__ + "img/line.3bd36153.svg";